import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/bg.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "user header",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong"),
  /*#__PURE__*/_createTextVNode(" BỆNH VIỆN Y HỌC CỔ TRUYỀN ĐÀ NẴNG.")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Địa chỉ CS1: "),
  /*#__PURE__*/_createTextVNode(" Đinh Gia Trinh, P.Hòa Xuân, Q.Cẩm Lệ, Tp. Đà Nẵng")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Địa chỉ CS2: "),
  /*#__PURE__*/_createTextVNode(" 342 Phan Châu Trinh, P.Bình Thuận, Q.Hải Châu, Tp. Đà Nẵng")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Số điện thoại: "),
  /*#__PURE__*/_createTextVNode(" 0905.658.333")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    title: _withCtx(() => []),
    content: _withCtx(() => [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5
    ]),
    footer: _withCtx(() => []),
    _: 1
  }))
}